var React = require('react');

function ShareLink (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2.11001","y":"9.77539","width":"7.85732","height":"14.4289","rx":"3.92866","transform":"rotate(-45 2.11001 9.77539)","stroke":"#FFB699","strokeWidth":"2","key":0}),React.createElement("rect",{"x":"9.79947","y":"11.8555","width":"7.85732","height":"14.4289","rx":"3.92866","transform":"rotate(-45 9.79947 11.8555)","stroke":"#FFB699","strokeWidth":"2","key":1})]);
}

ShareLink.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none"};

module.exports = ShareLink;

ShareLink.default = ShareLink;
